import React, { Component } from 'react';
import { View, Dimensions } from 'react-native';
import App from './src/App';
import { setTopLevelNavigator } from './src/navigators/NavigationService';

export default class ResponsiveApp extends Component {
  constructor(props) {
    super(props);

    this.state = {
      window: Dimensions.get('window'),
    };
  }

  // eslint-disable-next-line react/no-deprecated
  componentWillMount() {
    Dimensions.addEventListener('change', this.handler);
  }

  componentWillUnmount() {
    // Important to stop updating state after unmount
    Dimensions.removeEventListener('change', this.handler);
  }

  handler = (dims) => this.setState(dims);

  render() {
    const { window } = this.state;
    const { width, height } = window;
    // const mode = height > width ? 'portrait' : 'landscape';
    // console.log(`New dimensions ${width}x${height} (${mode})`);

    return (
      <View style={{ flex: 1, width, height }}>
        <App ref={(navigatorRef) => {
          setTopLevelNavigator(navigatorRef);
        }}
        />
      </View>
    );
  }
}
